import React from 'react';
import {Helmet} from "react-helmet";
import Header from "../../components/Header";
import CorporateSignUps from "../../components/CorporateSignUp";
import Footer from "../../components/Footer";

import './CorporateSignUp.styles.css'; 

const CorporateSignUp = () => {
	
	return (
		<div>
			<Helmet>
				<title>Corporate Sign Up</title>
			</Helmet>
			<Header/>
			<CorporateSignUps/>
			<Footer/>
		</div>
	); 
}; 

export default CorporateSignUp;